import { useState, useCallback } from 'react'
import axios from 'axios'
import { getAppConfigSetting } from '../utils'
import { ACCOUNTS_API, SENTINEL_API } from './constants'
import useAccount from '../hooks/useAccount'

interface AccountOwner {
  ownerType: string
  homeAddress: {
    state: string
  }
}

export function useWaiverStates(): boolean {
  const [shouldDisplayWaiver, setShouldDisplayWaiver] = useState(false)
  const getAccountsApi = `${getAppConfigSetting('apiUrl')}${ACCOUNTS_API}`
  const { account } = useAccount()

  const getAccountDetails = useCallback(async () => {
    try {
      return await axios.get(`${getAccountsApi}/${account.accountNumber}/owners?ownerType=PRIMARY_OWNER`, {
        withCredentials: true
      })
    } catch (error) {
      console.error('Error fetching account details', error)
      return { data: [] }
    }
  }, [account, getAccountsApi])

  const fetchWaiverStates = useCallback(
    async () =>
      axios.get(`${getAppConfigSetting('apiUrl')}${SENTINEL_API}/ira_constraints/waiver_eligible_states`, {
        withCredentials: true
      }),
    []
  )

  const displayWaver = async () => {
    const [primaryOwnerResp, waiverStatesResp] = await Promise.all([getAccountDetails(), fetchWaiverStates()])
    if (
      waiverStatesResp?.data.states.includes(
        primaryOwnerResp.data[0]?.homeAddress.state || primaryOwnerResp.data[0]?.mailingAddress.state
      )
    ) {
      setShouldDisplayWaiver(true)
    }
  }
  if (account) {
    displayWaver()
  }
  return shouldDisplayWaiver
}
